import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

function Randomizer(props) {
  const millsAds = [
    {
      image: '/dvmf-2023/ads/adibs.jpg',
      link: 'https://adibs.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Adibs',
      class: 'webFormat biomerieux',
    },
    {
      image: '/dvmf-2023/ads/bmw-murray.jpg',
      link: 'https://bmwutah.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'BMW of Murray',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2023/ads/bear-lake.jpg',
      link: 'https://bearlake.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Bear Lake Utah',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2023/ads/mercedes-slc.jpg',
      link: 'https://kengarffmercedes.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Mercedes-Benz of Salt Lake City',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2023/ads/peak-art-frame.jpg',
      link: 'https://peakartandframe.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Peak Art & Frame',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2023/ads/nature-conservancy.jpg',
      link: 'https://nature.org/utah/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'The Nature Conservancy of Utah',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2023/ads/oc-tanner.jpg',
      link: 'https://octannerjewelers.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'OC Tanner Jewelers',
      class: 'webFormat octanner',
    },
    {
      image: '/dvmf-2023/ads/byu-museum-art.jpg',
      link: 'https://redledges.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Red Ledges Utah',
      class: 'webFormat redledges',
    },
    {
      image: '/dvmf-2023/ads/cache-valley.jpg',
      link: 'https://explorelogan.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Explore Logan',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2023/ads/hogle-zoo.jpg',
      link: 'https://www.hoglezoo.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Hogle Zoo',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2023/ads/tuacahn.jpg',
      link: 'https://www.tuacahn.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Tuacahn',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2023/ads/ufo.jpg',
      link: 'https://www.utahfestival.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Utah Festival Opera',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2023/ads/challenger-school.jpg',
      link: 'https://www.challengerschool.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Challenger School',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2023/ads/utah-highway.jpg',
      link: 'https://ridetolive.utah.gov/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Ride to Live',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2023/ads/hamilton-park.jpg',
      link: 'https://hamiltonparkinteriors.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Hamilton Park Interiors',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2023/ads/rc-willey.jpg',
      link: 'https://www.rcwilley.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'RC Willey',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2023/ads/ufirst-cu.jpg',
      link: 'https://www.ufirstcu.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'UFirst Credit Union',
      class: 'webFormat',
    },
  ];

  const [randomAd] = React.useState(
    millsAds[Math.floor(Math.random() * millsAds.length)]
  );

  return (
    <>
      <br />
      <OutboundLink
        href={randomAd.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={randomAd.image}
          alt={randomAd.alt}
          className={randomAd.class}
        />
      </OutboundLink>
      <hr />
      <br />
    </>
  );
}

export default Randomizer;
